import React, { useEffect, useState } from "react";
import {
  createDatabase,
  fetchDataFromIndexedDB,
  storeDataInIndexedDB,
} from "../Hooks/IndexedDBUtils";
import axios from "axios";
import toast from "react-hot-toast";
import { db4 } from "./UserMenu";
import CustomForm from "./CustomForm";
import { MdClose } from "react-icons/md";
import CustomModal from "./CustomModal";

const { REACT_APP_BASE_URL, REACT_APP_HUBSPOT_PORTAL_ID } = process.env;

const CommonSurveySelection = ({ contactEmail, userId }) => {
  const [formList, setFormList] = useState([]);
  const [activeForm, setActiveForm] = useState(formList?.[0] || null);
  const [surveyData, setSurveyData] = useState([]);
  const [email, setEmail] = useState("");
  const [selectValue, setSelectValue] = useState("");
  const [canvasserEmail, setCanvasserMail] = useState("");
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [refreshBtn, setRefreshBtn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem("token");
  const surveyFieldDatabase = createDatabase(
    "surveyFieldDB",
    "surveyFieldStore"
  );

  const getSurveyFormList = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_BASE_URL}/list_survey_forms`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let formsAll = response?.data?.forms_all || [];
      localStorage.setItem("forms_all", JSON.stringify(formsAll));
    } catch (error) {
      toast.error("Error while fetching forms");
      console.log(error);
      localStorage.setItem("forms_all", JSON.stringify([]));
    }

    // Retrieve from local storage and set the form list and active form
    const storedFormsAll = JSON.parse(
      localStorage.getItem("forms_all") || "[]"
    );
    setFormList(storedFormsAll);
    setActiveForm(storedFormsAll[0]);
  };
  const getCurrentUser = async () => {
    try {
      const response = await axios.post(
        `${REACT_APP_BASE_URL}/user`,
        {
          email: email,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCanvasserMail(response?.data?.email);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSurveyData = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_BASE_URL}/get_survey_form`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const surveyField = response?.data?.fieldGroups;
      const surveyFieldWithId = surveyField.map((field, index) => ({
        id: index + 1,
        ...field,
      }));
      setSurveyData(surveyFieldWithId);
      if (surveyField.length > 0) {
        storeDataInIndexedDB(
          surveyFieldDatabase,
          "surveyFieldStore",
          surveyFieldWithId
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  // API call after form submitted
  const makeEmptyEmail = async () => {
    if (userId) {
      try {
        await axios.post(
          `${REACT_APP_BASE_URL}/makeEmptyEmail`,
          {
            contactId: userId,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } catch (error) {
        console.error("Error making email empty:", error);
        toast.error(
          error?.response?.data?.message ||
          error?.message ||
          "Failed to make email empty after form submission."
        );
      }
    }
  };

  useEffect(() => {
    fetchDataFromIndexedDB(surveyFieldDatabase, "surveyFieldStore").then(
      (data) => {
        if (!navigator.onLine && Array.isArray(data)) {
          setSurveyData(data);
        }
      }
    );
    fetchDataFromIndexedDB(db4, "userProfileStore").then((data) => {
      if (Array.isArray(data) && data.length > 0) {
        setCanvasserMail(data[0]?.email);
      } else if (typeof data === "object" && Object.keys(data).length > 0) {
        setCanvasserMail(data?.email);
      }
    });
  }, []);

  useEffect(() => {
    if (navigator.onLine) {
      getCurrentUser();
      fetchSurveyData();
    }
  }, []);

  useEffect(() => {
    if (navigator.onLine) {
      getSurveyFormList();
    } else {
      const storedFormsAll = JSON.parse(
        localStorage.getItem("forms_all") || "[]"
      );
      setFormList(storedFormsAll);
      setActiveForm(storedFormsAll?.[0]);
    }
  }, []);

  const handleRefresh = (reloadScript) => {
    if (navigator.onLine) {
      reloadScript(true);
    }
  };

  const handleSelectChange = (e) => {
    const selectedIndex = e.target.value;
    setSelectValue(e.target.value);
    const selectedData = formList[selectedIndex];
    setActiveForm(selectedData);
    setIsOpen(true);
  };

  return (
    <div>
      <label className="block text-gray-500 font-bold  mb-2">
        Select Survey
      </label>
      <select
        className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
        id="dropdown"
        onChange={handleSelectChange}
        value={selectValue}
        required
      >
        <option value="">Select...</option>
        {formList?.map((data, index) => {
          return <option key={index} value={index}>{data?.form_tab}</option>;
        })}
      </select>

      {activeForm?.form && (
        <CustomModal
          open={modalIsOpen}
          onClose={() => {
            setIsOpen(false);
            setSelectValue("");
            makeEmptyEmail();
          }}
          panelclassName="xl:max-w-6xl lg:max-w-5xl md:max-w-3xl max-w-2xl sm:w-full"
        >
          <div className="flex w-full items-center justify-between mb-8 gap-5 flex-wrap">
            <h2 className="flex justify-center">{activeForm?.form_tab}</h2>
            <button
              className="text-2xl bg-canvas-primary/10 p-2 rounded-xl text-canvas-primary"
              onClick={() => {
                setIsOpen(false);
                setSelectValue("");
                makeEmptyEmail();
              }}
            >
              <MdClose />
            </button>
          </div>
          {isLoading && (
            <div className="w-full flex items-center justify-center p-6">
              <svg
                aria-hidden="true"
                className="w-6 h-6 lg:w-7 lg:h-7 text-canvas-primary animate-spin fill-gray-100"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            </div>
          )}
          <CustomForm
            handleRefresh={handleRefresh}
            key={activeForm?.id}
            refreshBtn={refreshBtn}
            setRefreshBtn={setRefreshBtn}
            contactEmail={contactEmail}
            region="na1"
            portalId={REACT_APP_HUBSPOT_PORTAL_ID}
            userId={userId}
            formId={activeForm?.form}
            setIsOpen={setIsOpen}
            setSelectValue={setSelectValue}
            setIsLoading={setIsLoading}
            noRefreshBtn
          />
        </CustomModal>
      )}
    </div>
  );
};

export default CommonSurveySelection;
